import Page from './Pages/DashboardPage';

export default {
    Page,
};
